import { Box, Chip, SxProps, Theme } from "@mui/material";

import ContactCard from "@/common/components/Contact/ContactCard";
import { CustomerContactDto } from "@/core/api/generated/v1";

import AppTooltip from "../../Tooltip/AppTooltip";
import GeneralByWhoDisplay from "../General/Display/GeneralByWhoDisplay";
import GeneralNationalIdentityNumberDisplay from "../General/Display/GeneralNationalIdentityNumberDisplay";

interface Props {
  contact?: CustomerContactDto | null;
  sx?: SxProps<Theme>;
}

export default function CustomerContactCard({ contact, sx }: Props) {
  if (!contact) {
    return null;
  }

  return (
    <ContactCard
      sx={sx}
      contact={{
        name: (
          <>
            {contact.personName?.name}{" "}
            {contact.isPrimary && (
              <Chip size='small' color='primary' variant='filled' label='Primary' sx={{ ml: 1 }} />
            )}
            {contact.isLinkedToExternalUser && (
              <Chip
                size='small'
                color='default'
                variant='outlined'
                label='Linked to external user'
                sx={{ ml: 1 }}
              />
            )}
          </>
        ),
        email: contact.email,
        phoneNumber: contact.phoneNumber,
      }}
    >
      <Box>
        <Box>
          <GeneralNationalIdentityNumberDisplay
            value={contact.nationalIdentityNumber}
            withIcon
            withCountryCode
            withCountryIcon
            withTooltip
          />
        </Box>

        {contact.userId && (
          <AppTooltip title='Contact user'>
            <Box component='span'>
              <GeneralByWhoDisplay
                who={{ userId: contact.userId }}
                size='compact'
                displayProps={{ detailsPopover: false }}
              />
            </Box>
          </AppTooltip>
        )}
      </Box>
    </ContactCard>
  );
}
